import { RedoFulfillmentToteSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-tote";
import { PickSessionSchema } from "@redotech/redo-fulfillment-wms-common/schema/pick-session";
import { locationIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";

export const getPickSessionByToteBarcode = {
  name: "getPickSessionByToteBarcode" as const,
  input: z.object({
    barcode: z.string().max(255),
    locationId: locationIdFormat.schema.nullish(),
  }),
  output: z.object({
    pickSession: PickSessionSchema.nullable(),
    tote: RedoFulfillmentToteSchema.nullable(),
    warning: z.string().optional(),
  }),
};

export type GetPickSessionByToteBarcodeInput = z.infer<
  typeof getPickSessionByToteBarcode.input
>;
